/** Stable media destination: a scheduled meeting never reuses its parent room. */
export function conferenceDestination(roomSlug: string, meetingId?: string): string {
  if (!roomSlug) throw new Error('Sala nu are un identificator valid.');
  if (!meetingId) return roomSlug;
  if (!/^[a-zA-Z0-9_-]{1,120}$/.test(meetingId)) throw new Error('Identificatorul întâlnirii este invalid.');
  return `meeting-${meetingId}`;
}
